<template>
    <div class="content-body">
        <div class="p-grid p-fluid dashboard card">
			<div class="p-col-7">
				<h4 class="card-title p-col-12" style="text-align: center;"> DATOS DE CONFIGURACIÓN </h4>
				<div class="p-field">
					<label for="codigo">Precio m3 </label>
					<InputText id="ruc" v-model="configuracion.preciom3"/>
				</div>
				<div class="p-field">
					<label for="nombre">Tarifa mínima</label>
					<InputText id="nombre" v-model="configuracion.tarifaMinima" />
				</div>
				<div class="p-field">
					<label for="nombre">Cantidad de decimales</label>
					<InputText id="representante" v-model="configuracion.numeroDecimales" />
				</div>
				<div class="p-field">
					<label for="nombre">Número de orden de corte</label>
					<InputText id="direccion" v-model="configuracion.ordenCorte" />
				</div>
                <div class="p-col-12 p-lg-12" >
					<Button label="Grabar" icon="pi pi-save" style="width:100px;margin-right:10px" class="p-button-primary" @click='grabarDatos'/>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import ConfiguracionService from "../../service/administracion/ConfiguracionService";
export default {
	data() {
		return {
			configuracion: {}
		}
	},
	configuracionService: null,
	created() {
		this.configuracionService = new ConfiguracionService();
	},
	mounted() {
		this.cargarDatosIniciales();
	},
	methods: {
		cargarDatosIniciales(){
			this.configuracionService.buscarConfiguracion().then( response => {
				this.configuracion = response.data;
			}).catch( error => {
				console.log(error);
			});
		},
		grabarDatos(){
			Swal.fire({ title: 'Grabar datos', text: "Esta seguro de realizar el proceso" , icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Si', cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    console.log(this.configuracion);
                    this.configuracionService.guardarConfiguracion(this.configuracion).then( () => {
						Swal.fire({ position: 'center', customClass: { container: 'my-swal' }, title: 'Correcto!', text: "Grabado correctamente", icon: 'success', showConfirmButton: true, timer: 6000 });
					}).catch( error => {
						console.log(error);
						Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al grabar", icon: 'warning', showConfirmButton: true, timer: 6000 });
					});
                }
            });
		}
	}
}
</script>
<style scoped lang="scss">

</style>